export const TABLE_PAGINATION_OPTIONS = [
  { key: 5, value: '5' },
  { key: 10, value: '10' },
  { key: 15, value: '15' },
]
